import { TeamListDTO } from '../team/team-list.dto';
import { UserListDTO } from '../user/user-list.dto';
import { AccountListDTO } from '../account/account-list.dto';
import { ContactListDTO } from '../contact/contact-list.dto';
import { BaseDTO } from '../global/base.dto';

export class CaseTableDTO extends BaseDTO {

    title: string;

    source: number;

    status: number;

    team: TeamListDTO;

    user: UserListDTO;

    account: AccountListDTO;

    contact: ContactListDTO;
    
}
